

const set = property => (state, payload) => (state[property] = payload)
const get = property => (state) => (state[property])

const defaultStateProc = () => ({
  selectedCamera: null,
  isLoadingHls: false,
  accountType: null,
  snapShot: null,
})

export default {
  namespaced: true,
  state: defaultStateProc(),
  getters: {
    selectedCamera: get('selectedCamera'),
    isLoadingHls: get('isLoadingHls'),
    accountType: get('accountType'),
    snapShot: get('snapShot'),
  },
  mutations: {
    setCamera: set('selectedCamera'),
    setLoadingHls: set('isLoadingHls'),
    setAccountType: set('accountType'),
    setSnapShot: set('snapShot'),
  },
  actions: {
    selectCamera(context,cameraId) {
      context.commit('setCamera', cameraId);
    },
    lodingHls(context, isLoadingHls) {
      context.commit('setLoadingHls', isLoadingHls);
    },
    accountType(context, accountType) {
      context.commit('setAccountType', accountType);
    },
    snapShot(context, snapShot) {
      context.commit('setSnapShot', snapShot);
    },
  },
}
